import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { cn, useMount } from '../../shared/lib/utils.ts'
import { urls } from '../../shared/urls.ts'
import {
  MOCK_ADVANCED_LESSON,
  MOCK_PSYCHOLOGY_LESSONS,
  MOCK_VOCAB_LESSONS,
} from '../../shared/data/practice.ts'
import { Button } from '../../shared/ui/button/button.tsx'
import { usePracticeStore } from './PracticeStore.ts'
import { useSnapshot } from 'valtio'
import { Spinner } from '../../shared/ui/spinner.tsx'
import { Icon } from '../../shared/ui/icon/icon.tsx'
import { useRef } from 'react'
// import { useState, useEffect } from 'react'
import { ProgressBar, ProgressTags } from './PracticeProgressBar.tsx'
import { AppMessageKeys } from '../../shared/translations/messages.ts'
import {
  TYPES_TIME_MAP,
  TYPES_WITH_SOUND,
} from '../../shared/data/lessonsTags.ts'
// import Joyride from 'react-joyride'
import { useAppModule } from '../appContext.ts'
import Rive from '@rive-app/react-canvas'
// import {
//   joyrideProps,
//   PRACTICE_TOUR_STEPS,
// } from '../../shared/data/joyride.tsx'

export interface IProgressBlockRects {
  top: number
  left: number
  width: number
}

export const VocabLesson = ({
  img,
  lessonText,
  lessonType,
  lessonTag,
  type,
  tag,
  id,
}: {
  img: string
  lessonText: string
  lessonTag: string
  lessonType: AppMessageKeys
  type: 'quick' | 'advanced'
  tag: string
  id: string
}) => {
  const navigate = useNavigate()

  // const isLastJoyrideStep =
  //   state.tourStepIndex === PRACTICE_TOUR_STEPS.length - 1

  const handleClick = () => {
    // if (isLastJoyrideStep) {
    //   void store.deleteMarketingHints()
    // }

    type === 'quick'
      ? navigate(urls.vocabLesson(lessonTag), {
          state: {
            lessonType: 'vocabulary',
            // isHelpVocabLesson: isLastJoyrideStep,
          },
        })
      : navigate(urls.practiceWords('select', lessonTag))
  }
  return (
    <div
      className="relative flex h-fit w-full cursor-pointer gap-12 rounded-16 bg-gray-light p-16"
      onClick={handleClick}
      id={id}
    >
      <div className="absolute right-10 top-10 flex flex-col  text-12 font-semibold">
        <div className="flex gap-10 opacity-40">
          {TYPES_WITH_SOUND.includes(tag) && (
            <Icon iconName="headphone" className="size-14" />
          )}
          {
            <FormattedMessage
              id="lessonType"
              values={{
                type: tag,
                count: TYPES_TIME_MAP[tag as keyof typeof TYPES_TIME_MAP],
                min: <FormattedMessage id="min" />,
              }}
            />
          }
        </div>
      </div>
      <div
        className={cn(
          'relative flex size-80 shrink-0 items-center justify-center rounded-full border-2 p-6',
          'border-lesson-icon-border',
        )}
      >
        <div
          className={cn(
            'flex size-full items-center justify-center overflow-hidden rounded-full',
            'bg-white',
          )}
        >
          <img className="w-full" src={img} alt="" />
        </div>
      </div>

      <div className="flex flex-col justify-center">
        <p className="text-14 font-extrabold text-black opacity-30">
          <FormattedMessage id={lessonType} />
        </p>
        <p className="text-18 font-bold">{lessonText}</p>
      </div>
    </div>
  )
}

export const PracticeView = () => {
  // const [showTour, setShowTour] = useState(false)
  const store = usePracticeStore()
  const state = useSnapshot(store.state)
  const wordsCount = state.words.count
  const module = useAppModule()
  const appState = useSnapshot(module.appStore.state)
  const isRu = appState.uiLocale === 'ru'
  const isPsychologyCourse = state.isPsychologyCourse
  // const shouldViewPracticeTour = state.hints?.marketingPracticeHint
  const navigate = useNavigate()
  useMount(() => {
    void store.getPracticeInfo()
  })

  // useEffect(() => {
  //   if (!shouldViewPracticeTour) return
  //   const timer = setTimeout(() => {
  //     setShowTour(true)
  //   }, 1000)

  //   return () => {
  //     clearTimeout(timer)
  //   }
  // }, [shouldViewPracticeTour])

  // const handleJoyrideCallback = (data: { index: number }) => {
  //   store.setTourIndex(data.index)
  // }

  const intl = useIntl()
  //   const [progressBlockRects, setProgressBlockRects] =
  //     useState<IProgressBlockRects | null>(null)

  const progressBlockRef = useRef<HTMLDivElement>(null)

  //   useMount(() => {
  //     if (progressBlockRef.current) {
  //       const rects = progressBlockRef.current.getBoundingClientRect()
  //       if (rects.top && rects.left && rects.width) {
  //         // setProgressBlockRects({
  //         //   top: rects.top + window.scrollY,
  //         //   left: rects.left,
  //         //   width: rects.width,
  //         // })
  //       }
  //     }
  //   })

  if (state.words.loading)
    return (
      <div className="flex h-dvh w-full items-center justify-center">
        <Spinner />
      </div>
    )

  return (
    <div className="relative w-full px-16 pb-100 pt-16 sm:mx-auto sm:w-800 xl:pb-0 2xl:w-1200 2xl:px-32 2xl:pt-32 2xl:text-18">
      <div id="practice-header">
        <h1 className="text-center text-18 font-bold 2xl:text-28">
          {isRu ? (
            <FormattedMessage id="practice.myTerms" />
          ) : (
            <FormattedMessage id="practice.header" />
          )}
        </h1>
        <Button
          size="small"
          rounded="full"
          bg="blue-gradient-shadow-inset"
          onClick={() => {
            navigate(urls.practiceWords())
          }}
          disabled={state.words.loading}
          className="absolute right-16 top-16 font-nunito-7-condensed"
        >
          {isPsychologyCourse ? (
            'Термины'
          ) : (
            <FormattedMessage
              id="wordsPluralLocale"
              values={{ count: wordsCount }}
            />
          )}
        </Button>
        <div className="mt-28 flex h-72 items-center justify-center text-center text-48 font-black">
          {wordsCount}
        </div>
        {!isRu && (
          <Button
            size="small"
            rounded="full"
            bg="transparent"
            className="mx-auto flex gap-6 border-2 border-lesson-icon-border px-16 py-2 font-nunito-7-semicondensed text-12 font-bold text-lesson-icon-border"
            onClick={() => {
              navigate(urls.practiceWords())
            }}
          >
            <Icon iconName="plus" size="xs" />
            <FormattedMessage id="addNewWord" />
          </Button>
        )}
      </div>
      {state.isEnglishCourse && wordsCount === 0 ? (
        <div
          className="mt-24 h-fit w-full rounded-12 bg-gray-light p-32 text-center text-gray7"
          data-testid="english-vocabulary-empty"
        >
          <p className="text-18 font-bold">
            <FormattedMessage id="practice.wordStatEmpty" />
          </p>
          <p className="mt-12 text-14">
            <FormattedMessage id="practice.takeFirstLesson" />
          </p>
        </div>
      ) : (
        <>
          <div id="practice-progress-block">
            <p className="mt-24 text-center text-14 text-gray4">
              {isRu ? (
                <FormattedMessage
                  id="practice.footerPsych"
                  values={{
                    boldText: (
                      <span className="font-bold">
                        {intl.formatMessage({ id: 'practice.strongTerms' })}
                      </span>
                    ),
                  }}
                />
              ) : (
                <FormattedMessage
                  id="metrics.footerText"
                  values={{
                    boldText: (
                      <span className="font-bold">
                        {intl.formatMessage({ id: 'metrics.footerBoldSpan' })}
                      </span>
                    ),
                  }}
                />
              )}
            </p>
            {isPsychologyCourse && (
              <div className="relative mx-auto mt-24 w-fit">
                <div className="pointer-events-none absolute -left-36 -top-12 h-36 w-36">
                  <Rive src="/animations/sparkle1.riv" />
                </div>
                <div className="pointer-events-none absolute -right-36 -top-14 h-36 w-36">
                  <Rive src="/animations/sparkle2.riv" />
                </div>
                <div className="pointer-events-none absolute -right-36 -bottom-8 h-36 w-36">
                  <Rive src="/animations/sparkle3.riv" />
                </div>
                <div className="pointer-events-none absolute -left-36 -bottom-14 h-36 w-36">
                  <Rive src="/animations/sparkle3.riv" />
                </div>
                <div className="pointer-events-none absolute right-0 -bottom-24 h-24 w-24">
                  <Rive src="/animations/sparkle2.riv" />
                </div>
                <Button
                  size="small"
                  rounded="full"
                  bg="blue-gradient"
                  className="px-20 font-nunito-7-condensed"
                  onClick={() => {
                    navigate(urls.practiceWords())
                  }}
                >
                  <FormattedMessage id="startStudy" />
                </Button>
              </div>
            )}

            <ProgressBar
              className="mt-24 flex h-132 w-full overflow-hidden rounded-12"
              ref={progressBlockRef}
            />
            <ProgressTags className="mt-12 flex w-full justify-center gap-16 rounded-b-18" />
          </div>

          {isRu ? (
            <>
              <h2
                className="mt-24 text-22 font-bold"
                id="practice-lesson-header-psychology"
              >
                <FormattedMessage id="navbar.lessons" />
              </h2>
              <div className="mt-6 flex flex-col gap-16">
                {MOCK_PSYCHOLOGY_LESSONS.map((el, i) => (
                  <VocabLesson
                    img={el.img}
                    lessonText={el.lessonText}
                    lessonType={el.lessonType}
                    lessonTag={el.lessonTag}
                    key={`psychology-lesson-${i}`}
                    type="quick"
                    tag={el.tag}
                    id={`psychology-lesson-${i}`}
                  />
                ))}
              </div>
            </>
          ) : (
            <>
              <MockLessons type="quick" />
              <MockLessons type="advanced" />
            </>
          )}
        </>
      )}
      {/* <Joyride
        steps={PRACTICE_TOUR_STEPS}
        run={showTour && !isMobile}
        callback={handleJoyrideCallback}
        {...joyrideProps}
      /> */}
    </div>
  )
}

const MockLessons = ({ type }: { type: 'quick' | 'advanced' }) => {
  const MOCK = type === 'quick' ? MOCK_VOCAB_LESSONS : MOCK_ADVANCED_LESSON
  return (
    <>
      <h2
        className="mt-24 text-22 font-bold"
        id={`practice-lesson-header-${type}`}
      >
        <FormattedMessage
          id={type === 'quick' ? 'quickStart' : 'advancedMode'}
        />
      </h2>
      <div className="mt-6 flex flex-col gap-16">
        {MOCK.map((el, i) => (
          <VocabLesson
            img={el.img}
            lessonText={el.lessonText}
            lessonType={el.lessonType}
            lessonTag={el.lessonTag}
            key={`vocab-lesson-${i}`}
            type={type}
            tag={el.tag}
            id={`vocab-lesson-${i}`}
          />
        ))}
      </div>
    </>
  )
}
